export const USP_TEXT = {
  'usp.next_day_delivery.description': {
    'en-GB': 'Guaranteed <strong>next day delivery</strong> on all flowers',
    'nl-NL':
      'Voor <strong>23.00</strong> besteld, <strong>vandaag verstuurd</strong>',
  },
  'usp.hand_picked.description': {
    'en-GB': '<strong>Designed</strong> by florists',
    'nl-NL': '<strong>Rechtstreeks</strong> van de <strong>veiling</strong>',
  },
  'usp.blooms_in_two_days.description': {
    'en-GB': 'Arrives in bud and <strong>blooms within 2 days</strong>',
    'nl-NL': '<strong>Dagverse</strong> kwaliteitsbloemen',
  },
  'usp.freshness_guarantee.description': {
    'en-GB': '<strong>7 day freshness</strong> or a free replacement',
    'nl-NL': '7 dagen <strong>versgarantie</strong>',
  },
  'usp.perfect_gift_companion.description': {
    'en-GB': 'Delivered with <strong>your Moonpig card</strong>',
    'nl-NL': 'Bezorgd met <strong>je Greetz-kaart</strong>',
  },
  'usp.plants.next_day_delivery.description': {
    'en-GB': 'Guaranteed <strong>next day delivery</strong> on all plants',
  },
  'usp.plants.expertly_selected.description': {
    'en-GB': 'Expertly selected by <strong>PATCH Plants</strong>',
  },
  'usp.plants.healthy_and_thriving.description': {
    'en-GB':
      'Delivered <strong>healthy</strong> and <strong>ready to thrive</strong>',
  },
  'usp.plants.perfect_gift_companion.description': {
    'en-GB': 'Delivered with <strong>your Moonpig card</strong>',
  },
}
